module.exports = __webpack_public_path__ + "static/media/certificate.9a027d57.svg";